import React from 'react'
import './SideBarSubMenu.css'
import { Link } from 'react-router-dom'
export default function SideBarSubMenu({ Menu, selectedMenuIndex, index }) {


    return (
        <div className={`sidebar-submenu ${selectedMenuIndex === index ? 'active' : ''}`}>
            <ul>
                {
                    Menu.subMenus[0]?.map((subMenu, index) => (
                        <li key={index}>
                            <Link to={`/products/`}>
                                {subMenu.title}
                            </Link>
                        </li>
                    ))
                }

            </ul>
        </div>
    )
}
